<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
        <div class="box">
          <admin-box-item title="호스팅 등록">
            <div class="columns is-multiline">
              <div class="column is-12">
                <admin-form-item label="호스팅 이름">
                  <input class="input"
                         v-model="value.name"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="호스팅 설명">
                  <input class="input"
                         v-model="value.desc"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12">
                <admin-form-item label="판매가격 사용여부">
                  <lp-radio :val.sync="value.price_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용', value:0},{label:'대체문구 사용', value:1}]"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-12" v-if="value.price_type===0">
                <admin-form-item label="가격">
                  <input class="input"
                         v-model="value.price"
                         type="number" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-12" v-else>
                <admin-form-item label="대체문구">
                  <input class="input"
                         v-model="value.price_text"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import LpRadio from "../../../module/common/LpRadio";
    export default {
        name: "HostingList",
      components: {LpRadio},
      created() {
          this.getData();
        },
        data() {
            return {
              value: {
                name: '',
                desc: '',
                price_type: 0,
                price: 0,
                price_text: ''
              }
            }
        },
        methods: {
          saveData() {
            if(this.$route.query.id) {
              this.$axios.patch(`admin/launchpack/hosting/${this.$route.query.id}`, this.value).then(res=>{
                this.toast('저장되었습니다.');
              })
            } else {
              this.$axios.post('admin/launchpack/hosting', this.value).then(res=>{
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath('launchpack/hosting'));
              })
            }
          },
          getData() {
            if(!this.$route.query.id) return;
            this.$axios.get(`admin/launchpack/hosting/${this.$route.query.id}`).then(res=>{
              this.value = res.data;
            })
          }
        }
    }
</script>
<style lang="stylus" scoped>
</style>
